export const sortBy = (array: any[], field: string, reverse = false) => {
    const compare = (a, b) => {
        if (a?.[field] < b?.[field]) {
            return reverse ? 1 : -1;
        }
        if (a?.[field] > b?.[field]) {
            return reverse ? -1 : 1;
        }
        return 0;
    };
    return Array.isArray(array)
        ? array.sort(compare)
        : array;
};
